import { createSlice, current } from '@reduxjs/toolkit';

const newCrew = { time: {}, user: {} };

const operatingCrewStore = createSlice({
  name: 'operatingCrew',
  initialState: {
    snapshot: null,
    crews: null,
    /** 데이터 변경 여부 */
    isUpdated: false,
    /** filter */
    clients: [],
    contractType: {},
    gender: {},
    searchValue: '',
  },
  reducers: {
    setIsUpdated: (state, { payload }) => {
      state.isUpdated = payload;
      return state;
    },
    setInitData: (state, { payload }) => {
      state.crews = payload.item;
      state.snapshot = payload;
      state.isUpdated = false;
      return state;
    },
    setData: (state, { payload }) => {
      state = state ? { ...state, ...payload } : { ...payload };
      state.isUpdated = true;
      return state;
    },
    // 크루 정보 업데이트
    setSubstitute: (state, { payload: { cardNo, value, key } }) => {
      state.crews = current(state).crews.map((crew, index) => {
        if (index === cardNo) {
          return {
            ...crew,
            [key]: !value // 크루정보 리셋하기
              ? {}
              : {
                  ...crew[key],
                  ...value,
                },
          };
        } else {
          return crew;
        }
      });

      state.isUpdated = true;
      return state;
    },
    // 크루 추가
    addSubstitute: (state, { payload }) => {
      state.crews =
        current(state).crews && current(state).crews.length !== 0
          ? [
              ...current(state).crews,
              {
                ...newCrew,
                time: {
                  ...newCrew.time,
                  dateBegin: payload.time.dateBegin,
                },
              },
            ]
          : [payload];

      state.isUpdated = true;
      /** filter */
      state.clients = [];
      state.contractType = {};
      state.gender = {};
      state.searchValue = '';

      return state;
    },
    // 크루 삭제
    deleteSubstitute: (state, { payload: { cardNo } }) => {
      state.crews.splice(cardNo, 1);
      state.isUpdated = false;
      return state;
    },
    resetSubstitute: (state, { payload: { cardNo } }) => {
      state.crews = current(state).crews.map((crew, index) => {
        if (index === cardNo) {
          // 서버에 저장된 데이터가 있다면 -> 서버 데이터로, 없다면 -> 빈값
          return current(state).snapshot?.item.length - 1 >= cardNo
            ? current(state).snapshot.item[cardNo]
            : newCrew;
        } else {
          return crew;
        }
      });

      state.isUpdated = false;
      return state;
    },
  },
});

export const crewActions = operatingCrewStore.actions;

export default operatingCrewStore.reducer;
